/*
 *  Copyright
 *
 *  Tegona S.A.
 *
 *  Tegona JS © 2017, Tegona S.A.
 *
 *  ALL RIGHTS RESERVED. THIS PROGRAM CONTAINS MATERIAL PROTECTED
 *  UNDER INTERNATIONAL AND SWITZERLAND COPYRIGHT LAWS AND TREATIES.
 *  ANY UNAUTHORIZED USE OF THE PROGRAM, INCLUDING REPRODUCTION,
 *  MODIFICATION, TRANSFER, TRANSMITTAL OR REPUBLICATION OF THIS
 *  MATERIAL IN ANY FORM OR BY ANY MEANS IS PROHIBITED WITHOUT
 *  SPECIFIC WRITTEN PERMISSION OF THE COPYRIGHT HOLDER.
 *
 *  copyright@tegona.com
*/

import React from 'react'
import Cookies from 'cookies-js'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'

import Header from 'components/common/Header'

import * as actions from 'actions/ApplicantPrestation'
import * as loginActions from 'actions/Login'

class Base extends React.Component {

  componentDidMount () {
    this.props.actions.loadStaticData()

    if (Cookies.get('isLogged') === 'true') {
      if (!this.props.user.uid) this.props.loginActions.setUserInformation()
    }
  }

  render () {    
    return (
      <Header
        options={this.props.headerOptions || []}
        page={this.props.page}
        handlePageChange={this.props.handlePageChange}
      >
        {
          this.props.children
        }
      </Header>
    )
  }
}

const mapStateToProps = (state) => ({
  user: state.User.user,
})

const mapActionsToProps = (dispatch) => ({
  actions: bindActionCreators(actions, dispatch),
  loginActions: bindActionCreators(loginActions, dispatch),
})

export default connect(
  mapStateToProps, 
  mapActionsToProps
)(Base)



// WEBPACK FOOTER //
// ./src/components/common/Base.js